import { useFormikContext } from 'formik';
import * as React from 'react';

import { SessionServerSelectors } from '../../../../app/selectors/SessionInfoSelectors';
import { Messages } from '../../../../codegen/Localize';
import { FormikCheckbox } from '../../../../commonInfra/components/FormikCheckbox';
import { SettingsSection } from '../../../components/common/SettingsSection';
import { useSelector } from '../../utils';
import { componentRegistryEntry } from '../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../site-settings/ReactSiteSettingsForSiteAdmin';
import { forceUncheckedIfUserVisibilityLimited, useUserVisibilityLimited } from './UserVisibilitySection';

export const VIZ_RECOMMENDATIONS_FIELD = 'settings.vizRecommendationsEnabled';
export const VIZ_RECOMMENDATIONS_USERNAME_ENABLED_FIELD = 'settings.vizRecUsernameVisibilityEnabled';

export type VizRecommendationsSectionProps = SiteSettingsForSiteAdminProps< 'vizRecommendationsEnabled'| 'vizRecUsernameVisibilityEnabled' | 'userVisibility'>;

export function VizRecommendationsSection() {
  // isVizRecommendationsEnabled checks both FeatureFlag and Server setting.
  const isVizRecommendationsEnabled = useSelector(SessionServerSelectors.isVizRecommendationsEnabled);
  const formik = useFormikContext<VizRecommendationsSectionProps>();
  const recommendationsEnabled = formik.values.settings.vizRecommendationsEnabled;
  const isUserVisibilityLimited = useUserVisibilityLimited();

  return !isVizRecommendationsEnabled ? null : (
    <SettingsSection title={Messages.vizRecommendationsSiteSettingTitle()}
                     testId={'recommendations-setting-section'}
                     description={Messages.vizRecommendationsDetails()}>
      <FormikCheckbox name={VIZ_RECOMMENDATIONS_FIELD}
                      label={Messages.vizRecommendationsSiteSettingsLabel()}
                      testId={'vizrec-site-setting'}>
      </FormikCheckbox>
      <FormikCheckbox name={VIZ_RECOMMENDATIONS_USERNAME_ENABLED_FIELD}
                      label={Messages.vizRecUsernameVisibilitySiteSettingsLabel()}
                      testId={'vizrec-username'}
                      disabled={isUserVisibilityLimited || !recommendationsEnabled}
                      {...forceUncheckedIfUserVisibilityLimited(isUserVisibilityLimited)}>
      </FormikCheckbox>
      {isUserVisibilityLimited &&
        <span data-tb-test-id={'vizrecommendations-uservisibility-warning'}>
          {Messages.userVisibilityWarning()}
        </span>
      }
    </SettingsSection>
  );
}

export const VizRecommendationsSectionSpecs = componentRegistryEntry({
  name: 'VizRecommendationsSection',
  component: VizRecommendationsSection
});
